import { render, staticRenderFns } from "./ScaniaVehicleInformationsMenu.vue?vue&type=template&id=2d5f1e38&"
import script from "./ScaniaVehicleInformationsMenu.vue?vue&type=script&lang=js&"
export * from "./ScaniaVehicleInformationsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports